module.exports = __webpack_public_path__ + "fb-tutorial-4-pl.png?f014563cf888bc942416430c6103a00c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/fb-tutorial-4-pl.png
// module id = /VEg
// module chunks = 46